<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">云田购</div>
        <div class="letterTitle">2020/4/12    23:00</div>
        <div class="twodiv">
          网站账号开通及试用可联系我们公司驻当地分公司业务人员
        </div>
        <div class="twodiv link"  >
           <span @click="toJangou()">http://rmd.ytzhihui.com</span>
        </div>
        <div class="twodiv">
          云田购是湖北三新文化传媒有限公司，以读者为中心、以人为本的服务理念，推出的一款由读者向图书馆荐购书目的应用。帮助图书馆更好的了解读者阅读需求，满足读者的个性化需求。对读者来说，不仅可以一键荐购想要阅读的书，后续还可跟踪荐购状态；对图书馆馆员来说，极大简化了荐购处理工作，提高工作效率。荐购的方式包括在版书目荐购和无数据荐购。
          为满足当下读者的个性化借阅需求，提高图书馆的资源利用率，云平台推出读者荐购服务。对读者来说，找到想要的书一键荐购，后续还可跟踪荐购状态；对图书馆馆员来说，带书目的荐购以及荐购规则的设定极大简化了荐购处理工作，提高工作效率。
        </div>
        <div class="twodiv">
          （1）在提高读者荐购积极性方面
        </div>
        <div class="threediv">
          简单易用：在百万书目库里搜出来后一键荐购，无需手动填写书目信息；
        </div>
        <div class="threediv">
          多终端：支持手机、电脑随时随地荐购，APP支持条形码扫描，无需输入；
        </div>
        <div class="threediv">
          反馈及时：荐购处理状态，到馆通知手机APP推送，反馈高效及时；
        </div>
        <div class="threediv">
          荐购排行：荐购大比拼，让读者收获成就感，定期奖励活动激励热心读者；
        </div>
        <div class="threediv">
          荐购排行：荐购大比拼，让读者收获成就感，定期奖励活动激励热心读者；
        </div>
        <div class="threediv">
          荐购排行：荐购大比拼，让读者收获成就感，定期奖励活动激励热心读者；
        </div>
        <div class="threediv">
          荐购升级：提供PDA现场借书，一步完成荐购+借阅，最大限度缩短了荐购和到馆借阅之间的时间差，让读者无需等待。
        </div>
        <div class="twodiv">
          （2）在方便老师审核管理方面
        </div>
        <div class="threediv">
          书目准确：全是有完善书目信息的荐购信息，无需多方查找，默认关闭模糊的无数据荐购功能；
        </div>
        <div class="threediv">
          馆藏查重：馆藏对接后，对于馆藏已有的书目，会屏蔽荐购按钮，并告知读者馆藏已有，避免老师处理无效信息；
        </div>
        <div class="threediv">
          条件拦截：老师可以在后台设定一系列拦截规则（分类、关键词、出版年、码洋等），被拦截的书目会屏蔽荐购按钮，并告知读者原因，无需老师手动回复；
        </div>
        <div class="threediv">
          自动通知：对荐购信息的处理情况（同意或不同意），系统会自动通知给荐购读者；馆藏对接后，荐购到馆的书目也会自动通知到所有荐购读者，无需老师逐一通知；
        </div>
        <div class="threediv">
          荐购统计：提供读者荐购统计、院系荐购统计等，方便图书馆举办各种荐购激励活动；也提供按分类、搜索词、出版社等维度统计荐购热点，帮助图书馆准确把握住读者需求；
        </div>
        <div class="threediv">
          衔接采访工作：荐购处理和采访工作一步完成，老师点击同意采购即加入购物车，提交订单后，订单状态会自动变更荐购状态，无需老师两边处理。
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import { listclassifyTypes, searchlist } from '@/api/img'
  import { selectUnionPublisher } from '@/api/pages'
  import MyAside from '@/components/MyAside.vue'
  import Cookies from 'js-cookie'
  import {Base64} from 'js-base64'
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // 进入直播
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      },
      toJangou(){
        if(Cookies.get('passPort') && Cookies.get('passWord')){
          window.open(`http://rmd.ytzhihui.com/login.html?passPort=${Cookies.get('passPort')}&orgGid=${Cookies.get('orgGid')}&passWord=${Base64.encode(Cookies.get('passWord'))}`);
        }else{
           window.open(`http://rmd.ytzhihui.com/login.html`)
        }
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
    &.link{
       span{
         cursor: pointer;
        text-decoration: underline;
       }
    }
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-Yun.vue